export default (data) => {
  return(
    {
      builderId: data._id ? data._id : "5fb2a5f3ea262c2e14e462ad",
      typeId: data.user ? "user" : "office",
      officeId: data.user ? data.user : data.office,
      primaryColor: data.primaryColor ? data.primaryColor : "#00163b",
      address: data.address ? data.address : "Guardia Vieja 181 OF 806 Providencia.",
      email: data.email ? data.email : "carol@arcogestion.cl",
      facebook: data.facebook ? data.facebook : "https://facebook.com",
      twitter: data.twitter ? data.twitter : "https://twitter.com",
      instagram: data.instagram ? data.instagram : "https://instagram.com/arcogestioninmobiliaria",
      favicon: data.favicon ? data.favicon : require("../images/icon.png"),      
      lat: data.lat ? data.lat : "-33.410167",
      lng: data.lng ? data.lng : "-70.655265",
      logo: data.logo ? data.logo : require("../images/logo.png"),
      logoDark: data.logoDark ? data.logoDark : require("../images/logo2.png"),
      movil: data.movil ? data.movil : "+56 9 4858 6901",
      movil2: data.movil2 ? data.movil2 : "+56 9 5198 9005",
      phone: data.phone ? data.phone : "+56 9 4858 6901",
      phone2: data.phone2 ? data.phone2 : "+56 9 5198 9005",
      
      footerText: data.footerText ? data.footerText : "Somos una empresa con mas de 20 años en el rubro del corretaje inmobiliario",
      home:{
        hero: {
          background: data.home && data.home.hero && data.home.hero.background ? data.home.hero.background : require("../images/template-home-hero-background.jpg"),
          title: data.home && data.home.hero && data.home.hero.title ? data.home.hero.title : "Tenemos propiedades <br /> exclusivas pensadas para tí"
        },        
        properties: {
          title: data.home && data.home.properties && data.home.properties.title ? data.home.properties.title : "Contamos con una selección exclusiva de propiedades.",
          maxProperties: data.home && data.home.properties && data.home.properties.maxProperties ? data.home.properties.maxProperties : 9,
          footer: data.home && data.home.properties && data.home.properties.footer ? data.home.properties.footer : "Estas son solo algunas de las propiedades que tenemos para ofrecerte",
          buttonText: data.home && data.home.properties && data.home.properties.buttonText ? data.home.properties.buttonText : "Ver más"
        },        
        about: {
          banner: {
            image: data.home && data.home.about && data.home.about.banner && data.home.about.banner.image ? data.home.about.banner.image : require("../images/template-home-about-hero-background.jpg"),
            title: data.home && data.home.about && data.home.about.banner && data.home.about.banner.title ? data.home.about.banner.title : "En ARCO GESTIÓN INMOBILIARIA SPA, nos guiamos por valores fundamentales que definen nuestra manera de trabajar.",
            subTitle: data.home && data.home.about && data.home.about.banner && data.home.about.banner.subTitle ? data.home.about.banner.subTitle : "Actuamos con profesionalismo, integridad y transparencia, manteniendo siempre los más altos estándares éticos y de calidad. Nuestro compromiso es cumplir y superar las expectativas de nuestros clientes, ofreciendo un servicio personalizado y atento a sus necesidades.",
            buttonText: data.home && data.home.about && data.home.about.banner && data.home.about.banner.buttonText ? data.home.about.banner.buttonText : "Conócenos"
          }
        },  
        services: {
          items: data.home && data.home.services && data.home.services.items.length ? data.home.services.items : [
            {
              title: "Compras",
              description: ""
            },
            {
              title: "Arriendo",
              description: ""
            },
            {
              title: "Compras",
              description: ""
            }
          ]
        },  
        reviews: {
          items: data.home && data.home.reviews && data.home.reviews.items.length ? data.home.reviews.items : [
            {
              id: null,
              review: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vulputate sapien at nisi volutpat dictum. Maecenas vel lorem tellus. Sed sit amet sollicitudin nisi. Sed consectetur eget orci sit amet condimentum.",
              author: "Cliente 1"
            },
            {
              id: null,
              review: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vulputate sapien at nisi volutpat dictum. Maecenas vel lorem tellus. Sed sit amet sollicitudin nisi. Sed consectetur eget orci sit amet condimentum.",
              author: "Cliente 2"
            },
            {
              id: null,
              review: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vulputate sapien at nisi volutpat dictum. Maecenas vel lorem tellus. Sed sit amet sollicitudin nisi. Sed consectetur eget orci sit amet condimentum.",
              author: "Cliente 3"
            }
          ]
        }                    
      },
      about:{
        hero: {
          background: data.about && data.about.hero && data.about.hero.background ? data.about.hero.background : require("../images/template-about-hero-background.jpg"),
          title: data.about && data.about.hero && data.about.hero.title ? data.about.hero.title : "Un equipo de profesionales especializados en el sector inmobiliario."
        },
        history: {
          background: data.about && data.about.history && data.about.history.background ? data.about.history.background : require("../images/template-about-history-background.jpg"),
          description: data.about && data.about.history && data.about.history.description ? data.about.history.description : "<p>En ARCO GESTIÓN INMOBILIARIA, contamos con varios años de experiencia en el mercado inmobiliario, destacándonos por nuestra empatía y compromiso con cada cliente. Ofrecemos un servicio personalizado, de excelencia y calidad, respaldado por nuestro profundo conocimiento comercial, que nos permite agregar valor a todos los proyectos y servicios que emprendemos, lo que nos ha ganado un reconocimiento destacado en el sector.<p/>",
          title: data.about && data.about.history && data.about.history.title ? data.about.history.title : "Nuestra Historia"
        },
        description: {
          items: data.about && data.about.description && data.about.description.items.length ? data.about.description.items : [
            {
              title: "Misión",
              description: "En ARCO GESTIÓN INMOBILIARIA, nuestra misión es proporcionar un servicio integral y confiable en la gestión inmobiliaria, ofreciendo soluciones personalizadas y efectivas a nuestros clientes. Nos comprometemos a mantener los más altos estándares de profesionalismo y ética, apoyándonos en nuestro amplio conocimiento del mercado y nuestras conexiones estratégicas. Trabajamos incansablemente para asegurar que cada transacción inspire confianza y satisfacción, colaborando estrechamente con Nexxos Chile para ofrecer resultados excepcionales en el sector oriente."
            },
            {
              title: "Visión",
              description: "Nuestra visión en ARCO GESTIÓN INMOBILIARIA es ser la empresa líder en gestión inmobiliaria en Chile, reconocida por nuestra excelencia, innovación y compromiso con la satisfacción del cliente. Aspiramos a expandir nuestras capacidades y servicios, estableciendo nuevos estándares en la industria inmobiliaria y creando relaciones duraderas basadas en la confianza y el respeto mutuo. Nos esforzamos por contribuir al éxito inmobiliario de nuestros clientes, convirtiéndonos en su aliado estratégico en cada etapa del proceso."
            },
            {
              title: "Valores",
              description: "En ARCO GESTIÓN INMOBILIARIA, nos destacamos por nuestro profesionalismo, integridad y compromiso con la excelencia. Fomentamos la confianza y la transparencia en todas nuestras transacciones. Innovamos continuamente, adaptándonos a las tendencias del mercado y colaborando estrechamente con partners estratégicos como Nexxos Chile. Nos guiamos por el conocimiento y la experiencia para tomar decisiones informadas, y actuamos con responsabilidad social, contribuyendo al desarrollo sostenible del sector inmobiliario."
            }
          ]
        },
        stats: {
          proffesionals: data.about && data.about.stats && data.about.stats.proffesionals ? data.about.stats.proffesionals : 70,
          properties: data.about && data.about.stats && data.about.stats.properties ? data.about.stats.properties : 1000,
          years: data.about && data.about.stats && data.about.stats.years ? data.about.stats.years : 50,
          transactions: data.about && data.about.stats && data.about.stats.transactions ? data.about.stats.transactions : 500
        },
        team: {
          visible: true,
          items: data.about && data.about.team && data.about.team.items.length ? data.about.team.items : [
            {
              avatar: require("../images/template-team-member-1.jpg"),
              cv: "Ingeniero Comercial, Master en Finanzas. Inversor inmobiliario, con 6 años de experiencia en Banca, Mesa de Dinero. 6 años en el corretaje de propiedades, especializado en el manejo de cartera de propiedades. ",
              email: "usuario1@example.com",
              fullName: "Usuario 1",
              phone: "+56 9 5555 5555"
            },
            {
              avatar: require("../images/template-team-member-2.jpg"),
              cv: "Ingeniero Comercial, Master en Finanzas. Inversor inmobiliario, con 6 años de experiencia en Banca.",
              email: "usuario2@example.com",
              fullName: "Usuario 2",
              phone: "+56 9 5555 5555"
            },
            {
              avatar: require("../images/template-team-member-3.jpg"),
              cv: "Ingeniero Comercial, Master en Finanzas. Inversor inmobiliario, con 6 años de experiencia en Banca, Mesa de Dinero. 6 años en el corretaje de propiedades, especializado en el manejo de cartera de propiedades. ",
              email: "usuario3@example.com",
              fullName: "Usuario 3",
              phone: "+56 9 5555 5555"
            },
            {
              //avatar: require("../images/template-team-member-4.jpg"),
              avatar: "",
              cv: "Ingeniero Comercial, Master en Finanzas. Inversor inmobiliario, con 6 años de experiencia en Banca, Mesa de Dinero. 6 años en el corretaje de propiedades, especializado en el manejo de cartera de propiedades. ",
              email: "usuario4@example.com",
              fullName: "Usuario 4",
              phone: "+56 9 5555 5555"
            }                          
          ]
        },
        ubication: {
          title:  data.about && data.about.ubication && data.about.ubication.title ? data.about.ubication.title : "¿Necesitas vender, arrendar o comprar una propiedad? Somos tu socio perfecto"
        }
      },
      contact: {
        map: {
          title: data.contact && data.contact.map && data.contact.map.title ? data.contact.map.title : "Encuéntranos en Guardia Vieja 181 OF 806 Providencia.",
          subTitle: data.contact && data.contact.map && data.contact.map.subTitle ? data.contact.map.subTitle : "234"
        },
        title: data.contact && data.contact.title ? data.contact.title : "¿Dudas? ¿Consultas? Estamos aquí para ayudarte.",
        subTitle: data.contact && data.contact.subTitle ? data.contact.subTitle : "Envianos un mensaje y uno de nuestros asesores se pondra en contacto a la brevedad"        
      },
    }
  )
}